import { Component } from '@angular/core';
import { Form, FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { InventoryService } from 'src/app/services/inventory.service';

@Component({
  selector: 'app-form-client',
  template: `
    <form [formGroup]="formClient" (ngSubmit)="submit()">
      <div class="form-group">
        <label for="name">Nombre</label>
        <input type="text" class="form-control" id="name" placeholder="Nombre">
      </div>
      <div class="form-group">
        <label for="description">Descripción</label>
        <input type="text" class="form-control" id="description" placeholder="Descripción">
      </div>
      <div class="form-group">
        <label for="website">Sitio web</label>
        <input type="text" class="form-control" id="website" placeholder="Sitio web">
      </div>
      <div class="form-group">
        <label for="phone">Teléfono</label>
        <input type="text" class="form-control" id="phone" placeholder="Teléfono">
      </div>
      <div class="form-group">
        <label for="email">Correo electrónico</label>
        <input type="email" class="form-control" id="email" placeholder="Correo electrónico">
      </div>
      <div class="form-group">
        <label for="contact">Contacto</label>
        <input type="text" class="form-control" id="contact" placeholder="Contacto">
      </div>
      <div class="form-group">
        <label for="link">Enlace</label>
        <input type="text" class="form-control" id="link" placeholder="Enlace">
      </div>
      <div class="form-group">
        <label for="image">Imagen</label>
        <input type="text" class="form-control" id="image" placeholder="Imagen">
      </div>
      <div class="form-group">
        <label for="notes">Notas</label>
        <input type="text" class="form-control" id="notes" placeholder="Notas">
      </div>
      <div class="form-group">
        <label for="is_customer">Es cliente</label>
        <input type="checkbox" class="form-control" id="is_customer">
      </div>
      <div class="form-group">
        <label for="is_supplier">Es proveedor</label>
        <input type="checkbox" class="form-control" id="is_supplier">
      </div>
      <div class="form-group">
        <label for="is_manufacturer">Es fabricante</label>
        <input type="checkbox" class="form-control" id="is_manufacturer">
      </div>
      <div class="form-group">
        <label for="currency">Moneda</label>
        <input type="text" class="form-control" id="currency" placeholder="Moneda">
      </div>
      <div class="form-group">
        <label for="metadata">Metadatos</label>
        <input type="text" class="form-control" id="metadata" placeholder="Metadatos">
      </div>
      <div class="form-group">
        <label for="active">Activo</label>
        <input type="checkbox" class="form-control" id="active">
      </div>
      <div class="form-group">
        <button type="submit" class="btn btn-primary">Guardar</button>
      </div>

    </form>
  `,
  styles: ``
})
export class FormClientComponent {

  formClient: FormGroup = new FormGroup({});

  constructor(
    private fb: FormBuilder,
    private invStore: InventoryService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {}

  initForm() {
    this.formClient = this.fb.group({
      id: [],
      name: [],
      description: [],
      website: [],
      phone: [],
      email: [],
      contact: [],
      link: [],
      image: [],
      notes: [],
      is_customer: [],
      is_supplier: [],
      is_manufacturer: [],
      currency: [],
      metadata: [],
      active: [],
    });
  }

  submit() {
    console.log(this.formClient.value);
    this.invStore.createClient(this.formClient.value).subscribe({
      next: (response: any) => {
        console.log(response);
        this.toastr.success('Cliente creado exitosamente');
      },
      error: (error: any) => {
        console.error(error);
        this.toastr.error('Ocurrió un error al crear el cliente');
      }
    });
  }

}
